// @generated by protobuf-ts 2.9.4 with parameter optimize_code_size,long_type_number,generate_dependencies
// @generated from protobuf file "Protos/comments.proto" (package "wuxiaworld.api.v2", syntax proto3)
// tslint:disable
import { Empty } from "../google/protobuf/empty";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../google/protobuf/timestamp";
import { UserItem } from "./users";
import { ChapterParagraph } from "./chapter_paragraphs";
import { Entity } from "./entity";
import { PageInfoResponse } from "./pagination";
import { PageInfoRequest } from "./pagination";
import { StringValue } from "../google/protobuf/wrappers";
import { Int32Value } from "../google/protobuf/wrappers";
/**
 * @generated from protobuf message wuxiaworld.api.v2.AddCommentRequest
 */
export interface AddCommentRequest {
    /**
     * @generated from protobuf field: int32 entityId = 1;
     */
    entityId: number;
    /**
     * @generated from protobuf field: google.protobuf.Int32Value parentId = 2;
     */
    parentId?: Int32Value;
    /**
     * @generated from protobuf field: string content = 3;
     */
    content: string;
    /**
     * @generated from protobuf field: google.protobuf.StringValue paragraphId = 4;
     */
    paragraphId?: StringValue;
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.AddCommentResponse
 */
export interface AddCommentResponse {
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.CommentItem item = 1;
     */
    item?: CommentItem;
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.UpdateCommentRequest
 */
export interface UpdateCommentRequest {
    /**
     * @generated from protobuf field: int32 id = 1;
     */
    id: number;
    /**
     * @generated from protobuf field: string content = 2;
     */
    content: string;
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.UpdateCommentResponse
 */
export interface UpdateCommentResponse {
    /**
     * @generated from protobuf field: bool result = 1;
     */
    result: boolean;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.CommentItem item = 2;
     */
    item?: CommentItem;
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.VoteCommentRequest
 */
export interface VoteCommentRequest {
    /**
     * @generated from protobuf field: int32 id = 1;
     */
    id: number;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.CommentVoteType type = 2;
     */
    type: CommentVoteType;
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.VoteCommentResponse
 */
export interface VoteCommentResponse {
    /**
     * @generated from protobuf field: bool result = 1;
     */
    result: boolean;
    /**
     * @generated from protobuf field: int32 upVotes = 2;
     */
    upVotes: number;
    /**
     * @generated from protobuf field: int32 downVotes = 3;
     */
    downVotes: number;
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.ReportCommentRequest
 */
export interface ReportCommentRequest {
    /**
     * @generated from protobuf field: int32 id = 1;
     */
    id: number;
    /**
     * @generated from protobuf field: string content = 2;
     */
    content: string;
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.GetCommentsRequest
 */
export interface GetCommentsRequest {
    /**
     * @generated from protobuf field: int32 entityId = 1;
     */
    entityId: number;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.CommentSortBy sortBy = 2;
     */
    sortBy: CommentSortBy;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.CommentSortDirection sortDirection = 3;
     */
    sortDirection: CommentSortDirection;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.PageInfoRequest pageInfo = 4;
     */
    pageInfo?: PageInfoRequest;
    /**
     * @generated from protobuf field: google.protobuf.StringValue paragraphId = 5;
     */
    paragraphId?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.Int32Value rootId = 6;
     */
    rootId?: Int32Value;
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.GetCommentsResponse
 */
export interface GetCommentsResponse {
    /**
     * @generated from protobuf field: repeated wuxiaworld.api.v2.CommentItem items = 1;
     */
    items: CommentItem[];
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.PageInfoResponse pageInfo = 2;
     */
    pageInfo?: PageInfoResponse;
    /**
     * @generated from protobuf field: int32 totalTopLevelItems = 3;
     */
    totalTopLevelItems: number;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.Entity entity = 4;
     */
    entity?: Entity;
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.GetCommentPageRequest
 */
export interface GetCommentPageRequest {
    /**
     * @generated from protobuf field: int32 id = 1;
     */
    id: number;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.CommentSortBy sortBy = 2;
     */
    sortBy: CommentSortBy;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.CommentSortDirection sortDirection = 3;
     */
    sortDirection: CommentSortDirection;
    /**
     * @generated from protobuf field: int32 count = 4;
     */
    count: number;
    /**
     * @generated from protobuf field: google.protobuf.StringValue paragraphId = 5;
     */
    paragraphId?: StringValue;
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.GetCommentPageResponse
 */
export interface GetCommentPageResponse {
    /**
     * @generated from protobuf field: int32 pageNumber = 1;
     */
    pageNumber: number;
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.CommentPosterSeriesInfo
 */
export interface CommentPosterSeriesInfo {
    /**
     * @generated from protobuf field: bool isChampion = 1;
     */
    isChampion: boolean;
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.CommentPosterEntityInfo
 */
export interface CommentPosterEntityInfo {
    /**
     * @generated from protobuf oneof: entityInfo
     */
    entityInfo: {
        oneofKind: "seriesInfo";
        /**
         * @generated from protobuf field: wuxiaworld.api.v2.CommentPosterSeriesInfo seriesInfo = 1;
         */
        seriesInfo: CommentPosterSeriesInfo;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.CommentStatus
 */
export interface CommentStatus {
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.CommentStatus.State state = 1;
     */
    state: CommentStatus_State;
    /**
     * @generated from protobuf oneof: status
     */
    status: {
        oneofKind: "hidden";
        /**
         * @generated from protobuf field: wuxiaworld.api.v2.CommentStatus.HiddenStatus hidden = 2;
         */
        hidden: CommentStatus_HiddenStatus;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.CommentStatus.HiddenStatus
 */
export interface CommentStatus_HiddenStatus {
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.CommentStatus.HiddenReason reason = 1;
     */
    reason: CommentStatus_HiddenReason;
}
/**
 * @generated from protobuf enum wuxiaworld.api.v2.CommentStatus.State
 */
export enum CommentStatus_State {
    /**
     * @generated from protobuf enum value: Default = 0;
     */
    Default = 0,
    /**
     * @generated from protobuf enum value: Approved = 1;
     */
    Approved = 1,
    /**
     * @generated from protobuf enum value: InModeration = 2;
     */
    InModeration = 2,
    /**
     * @generated from protobuf enum value: Spam = 3;
     */
    Spam = 3,
    /**
     * @generated from protobuf enum value: Trashed = 4;
     */
    Trashed = 4,
    /**
     * @generated from protobuf enum value: Hidden = 5;
     */
    Hidden = 5
}
/**
 * @generated from protobuf enum wuxiaworld.api.v2.CommentStatus.HiddenReason
 */
export enum CommentStatus_HiddenReason {
    /**
     * @generated from protobuf enum value: None = 0;
     */
    None = 0,
    /**
     * @generated from protobuf enum value: Reporter = 1;
     */
    Reporter = 1,
    /**
     * @generated from protobuf enum value: Reported = 2;
     */
    Reported = 2
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.CommentsEntityInfo
 */
export interface CommentsEntityInfo {
    /**
     * @generated from protobuf oneof: info
     */
    info: {
        oneofKind: "chaptersInfo";
        /**
         * @generated from protobuf field: wuxiaworld.api.v2.CommentChaptersEntityInfo chaptersInfo = 1;
         */
        chaptersInfo: CommentChaptersEntityInfo;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.CommentChaptersEntityInfo
 */
export interface CommentChaptersEntityInfo {
    /**
     * @generated from protobuf field: ChapterParagraph paragraph = 1;
     */
    paragraph?: ChapterParagraph;
}
/**
 * @generated from protobuf message wuxiaworld.api.v2.CommentItem
 */
export interface CommentItem {
    /**
     * @generated from protobuf field: int32 id = 1;
     */
    id: number;
    /**
     * @generated from protobuf field: google.protobuf.StringValue content = 2;
     */
    content?: StringValue;
    /**
     * @generated from protobuf field: bool edited = 3;
     */
    edited: boolean;
    /**
     * @generated from protobuf field: int32 upVotes = 4;
     */
    upVotes: number;
    /**
     * @generated from protobuf field: int32 downVotes = 5;
     */
    downVotes: number;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.UserItem poster = 6;
     */
    poster?: UserItem;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp timeCommented = 7;
     */
    timeCommented?: Timestamp;
    /**
     * @generated from protobuf field: bool deleted = 8;
     */
    deleted: boolean;
    /**
     * @generated from protobuf field: bool approved = 9;
     */
    approved: boolean;
    /**
     * @generated from protobuf field: int32 depth = 10;
     */
    depth: number;
    /**
     * @generated from protobuf field: repeated wuxiaworld.api.v2.CommentItem children = 11;
     */
    children: CommentItem[];
    /**
     * @generated from protobuf field: google.protobuf.Int32Value rootId = 12;
     */
    rootId?: Int32Value;
    /**
     * @generated from protobuf field: google.protobuf.Int32Value parentId = 13;
     */
    parentId?: Int32Value;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.CommentPosterEntityInfo posterEntityInfo = 14;
     */
    posterEntityInfo?: CommentPosterEntityInfo;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.CommentStatus status = 15;
     */
    status?: CommentStatus;
    /**
     * @generated from protobuf field: wuxiaworld.api.v2.CommentsEntityInfo entityInfo = 16;
     */
    entityInfo?: CommentsEntityInfo;
}
/**
 * @generated from protobuf enum wuxiaworld.api.v2.CommentVoteType
 */
export enum CommentVoteType {
    /**
     * @generated from protobuf enum value: DownVote = 0;
     */
    DownVote = 0,
    /**
     * @generated from protobuf enum value: UpVote = 1;
     */
    UpVote = 1
}
/**
 * @generated from protobuf enum wuxiaworld.api.v2.CommentSortBy
 */
export enum CommentSortBy {
    /**
     * @generated from protobuf enum value: Default = 0;
     */
    Default = 0,
    /**
     * @generated from protobuf enum value: Time = 1;
     */
    Time = 1,
    /**
     * @generated from protobuf enum value: Top = 2;
     */
    Top = 2
}
/**
 * @generated from protobuf enum wuxiaworld.api.v2.CommentSortDirection
 */
export enum CommentSortDirection {
    /**
     * @generated from protobuf enum value: Asc = 0;
     */
    Asc = 0,
    /**
     * @generated from protobuf enum value: Desc = 1;
     */
    Desc = 1
}
// @generated message type with reflection information, may provide speed optimized methods
class AddCommentRequest$Type extends MessageType<AddCommentRequest> {
    constructor() {
        super("wuxiaworld.api.v2.AddCommentRequest", [
            { no: 1, name: "entityId", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "wuxiaworld.api.v2.required": { value: true } } },
            { no: 2, name: "parentId", kind: "message", T: () => Int32Value },
            { no: 3, name: "content", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "wuxiaworld.api.v2.stringLength": { minLength: { value: 1 }, maxLength: { value: 2048 }, errorMessage: { value: "Comment must have a length between {0} and {1} characters" } } } },
            { no: 4, name: "paragraphId", kind: "message", T: () => StringValue }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.AddCommentRequest
 */
export const AddCommentRequest = new AddCommentRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddCommentResponse$Type extends MessageType<AddCommentResponse> {
    constructor() {
        super("wuxiaworld.api.v2.AddCommentResponse", [
            { no: 1, name: "item", kind: "message", T: () => CommentItem }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.AddCommentResponse
 */
export const AddCommentResponse = new AddCommentResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCommentRequest$Type extends MessageType<UpdateCommentRequest> {
    constructor() {
        super("wuxiaworld.api.v2.UpdateCommentRequest", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "content", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "wuxiaworld.api.v2.stringLength": { minLength: { value: 1 }, maxLength: { value: 2048 }, errorMessage: { value: "Comment must have a length between {0} and {1} characters" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.UpdateCommentRequest
 */
export const UpdateCommentRequest = new UpdateCommentRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCommentResponse$Type extends MessageType<UpdateCommentResponse> {
    constructor() {
        super("wuxiaworld.api.v2.UpdateCommentResponse", [
            { no: 1, name: "result", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "item", kind: "message", T: () => CommentItem }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.UpdateCommentResponse
 */
export const UpdateCommentResponse = new UpdateCommentResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VoteCommentRequest$Type extends MessageType<VoteCommentRequest> {
    constructor() {
        super("wuxiaworld.api.v2.VoteCommentRequest", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "type", kind: "enum", T: () => ["wuxiaworld.api.v2.CommentVoteType", CommentVoteType] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.VoteCommentRequest
 */
export const VoteCommentRequest = new VoteCommentRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VoteCommentResponse$Type extends MessageType<VoteCommentResponse> {
    constructor() {
        super("wuxiaworld.api.v2.VoteCommentResponse", [
            { no: 1, name: "result", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "upVotes", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "downVotes", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.VoteCommentResponse
 */
export const VoteCommentResponse = new VoteCommentResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReportCommentRequest$Type extends MessageType<ReportCommentRequest> {
    constructor() {
        super("wuxiaworld.api.v2.ReportCommentRequest", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "content", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "wuxiaworld.api.v2.stringLength": { minLength: { value: 1 }, maxLength: { value: 2048 }, errorMessage: { value: "Report reason must have a length between {0} and {1} characters" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.ReportCommentRequest
 */
export const ReportCommentRequest = new ReportCommentRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCommentsRequest$Type extends MessageType<GetCommentsRequest> {
    constructor() {
        super("wuxiaworld.api.v2.GetCommentsRequest", [
            { no: 1, name: "entityId", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "sortBy", kind: "enum", T: () => ["wuxiaworld.api.v2.CommentSortBy", CommentSortBy] },
            { no: 3, name: "sortDirection", kind: "enum", T: () => ["wuxiaworld.api.v2.CommentSortDirection", CommentSortDirection] },
            { no: 4, name: "pageInfo", kind: "message", T: () => PageInfoRequest, options: { "wuxiaworld.api.v2.required": { value: true } } },
            { no: 5, name: "paragraphId", kind: "message", T: () => StringValue },
            { no: 6, name: "rootId", kind: "message", T: () => Int32Value }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.GetCommentsRequest
 */
export const GetCommentsRequest = new GetCommentsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCommentsResponse$Type extends MessageType<GetCommentsResponse> {
    constructor() {
        super("wuxiaworld.api.v2.GetCommentsResponse", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => CommentItem },
            { no: 2, name: "pageInfo", kind: "message", T: () => PageInfoResponse },
            { no: 3, name: "totalTopLevelItems", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "entity", kind: "message", T: () => Entity }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.GetCommentsResponse
 */
export const GetCommentsResponse = new GetCommentsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCommentPageRequest$Type extends MessageType<GetCommentPageRequest> {
    constructor() {
        super("wuxiaworld.api.v2.GetCommentPageRequest", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "sortBy", kind: "enum", T: () => ["wuxiaworld.api.v2.CommentSortBy", CommentSortBy] },
            { no: 3, name: "sortDirection", kind: "enum", T: () => ["wuxiaworld.api.v2.CommentSortDirection", CommentSortDirection] },
            { no: 4, name: "count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "paragraphId", kind: "message", T: () => StringValue }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.GetCommentPageRequest
 */
export const GetCommentPageRequest = new GetCommentPageRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCommentPageResponse$Type extends MessageType<GetCommentPageResponse> {
    constructor() {
        super("wuxiaworld.api.v2.GetCommentPageResponse", [
            { no: 1, name: "pageNumber", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.GetCommentPageResponse
 */
export const GetCommentPageResponse = new GetCommentPageResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CommentPosterSeriesInfo$Type extends MessageType<CommentPosterSeriesInfo> {
    constructor() {
        super("wuxiaworld.api.v2.CommentPosterSeriesInfo", [
            { no: 1, name: "isChampion", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.CommentPosterSeriesInfo
 */
export const CommentPosterSeriesInfo = new CommentPosterSeriesInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CommentPosterEntityInfo$Type extends MessageType<CommentPosterEntityInfo> {
    constructor() {
        super("wuxiaworld.api.v2.CommentPosterEntityInfo", [
            { no: 1, name: "seriesInfo", kind: "message", oneof: "entityInfo", T: () => CommentPosterSeriesInfo }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.CommentPosterEntityInfo
 */
export const CommentPosterEntityInfo = new CommentPosterEntityInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CommentStatus$Type extends MessageType<CommentStatus> {
    constructor() {
        super("wuxiaworld.api.v2.CommentStatus", [
            { no: 1, name: "state", kind: "enum", T: () => ["wuxiaworld.api.v2.CommentStatus.State", CommentStatus_State] },
            { no: 2, name: "hidden", kind: "message", oneof: "status", T: () => CommentStatus_HiddenStatus }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.CommentStatus
 */
export const CommentStatus = new CommentStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CommentStatus_HiddenStatus$Type extends MessageType<CommentStatus_HiddenStatus> {
    constructor() {
        super("wuxiaworld.api.v2.CommentStatus.HiddenStatus", [
            { no: 1, name: "reason", kind: "enum", T: () => ["wuxiaworld.api.v2.CommentStatus.HiddenReason", CommentStatus_HiddenReason] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.CommentStatus.HiddenStatus
 */
export const CommentStatus_HiddenStatus = new CommentStatus_HiddenStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CommentsEntityInfo$Type extends MessageType<CommentsEntityInfo> {
    constructor() {
        super("wuxiaworld.api.v2.CommentsEntityInfo", [
            { no: 1, name: "chaptersInfo", kind: "message", oneof: "info", T: () => CommentChaptersEntityInfo }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.CommentsEntityInfo
 */
export const CommentsEntityInfo = new CommentsEntityInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CommentChaptersEntityInfo$Type extends MessageType<CommentChaptersEntityInfo> {
    constructor() {
        super("wuxiaworld.api.v2.CommentChaptersEntityInfo", [
            { no: 1, name: "paragraph", kind: "message", T: () => ChapterParagraph }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.CommentChaptersEntityInfo
 */
export const CommentChaptersEntityInfo = new CommentChaptersEntityInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CommentItem$Type extends MessageType<CommentItem> {
    constructor() {
        super("wuxiaworld.api.v2.CommentItem", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "content", kind: "message", T: () => StringValue },
            { no: 3, name: "edited", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "upVotes", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "downVotes", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "poster", kind: "message", T: () => UserItem },
            { no: 7, name: "timeCommented", kind: "message", T: () => Timestamp },
            { no: 8, name: "deleted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "approved", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "depth", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "children", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => CommentItem },
            { no: 12, name: "rootId", kind: "message", T: () => Int32Value },
            { no: 13, name: "parentId", kind: "message", T: () => Int32Value },
            { no: 14, name: "posterEntityInfo", kind: "message", T: () => CommentPosterEntityInfo },
            { no: 15, name: "status", kind: "message", T: () => CommentStatus },
            { no: 16, name: "entityInfo", kind: "message", T: () => CommentsEntityInfo }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message wuxiaworld.api.v2.CommentItem
 */
export const CommentItem = new CommentItem$Type();
/**
 * @generated ServiceType for protobuf service wuxiaworld.api.v2.Comments
 */
export const Comments = new ServiceType("wuxiaworld.api.v2.Comments", [
    { name: "AddComment", options: {}, I: AddCommentRequest, O: AddCommentResponse },
    { name: "UpdateComment", options: {}, I: UpdateCommentRequest, O: UpdateCommentResponse },
    { name: "VoteComment", options: {}, I: VoteCommentRequest, O: VoteCommentResponse },
    { name: "ReportComment", options: {}, I: ReportCommentRequest, O: Empty },
    { name: "GetComments", options: {}, I: GetCommentsRequest, O: GetCommentsResponse },
    { name: "GetCommentPage", options: {}, I: GetCommentPageRequest, O: GetCommentPageResponse }
]);
